import { ItemizedLineItem, Kitchen } from '@rta/rta-blueprint-library';
import { Font, Text, View } from '@react-pdf/renderer';

import { fontConfig } from '../font-config';
import { formatPrice } from '../../../helpers';
import { styleSheet } from '../style-sheet';

Font.register(fontConfig);

export type EstimateItemizedProps = {
  data: {
    kitchen: Kitchen;
  };
}
// Create Document Component
export const EstimateAssemblyCost = (data: EstimateItemizedProps) => {
	const { kitchen } = data.data;

	const itemData = kitchen.itemizedMsrp;
	const islandData = itemData?.islands ?? null;
	const islands = kitchen.design.islands.orderedChildren;
	const numIslands = islands.length;
	const totalFeet = islands.reduce((sum, island) => sum + island.linearFeet, 0);
	const assemblyCost = (numIslands * 250) + (totalFeet * 150);

	return (
		<View style={styleSheet.comments}>
			<Text style={styleSheet.commentHeading}>Estimated Assembly Cost</Text>
			<Text style={styleSheet.safeDiscountNotice}>Amount below is a national average for what the assembly may cost. This number is not reflected in the current quote for your design. To receive an itemized assembly quote, we will get you in contact with our Installer Network. Please note that assembly cost does not include utility line connections or trash removal. These services may require separate arrangements and additional costs.</Text>
			<View style={styleSheet.horizontalRule} />

			<Text style={styleSheet.bold}>SKUs Factored into Linear Footage:</Text>

			{/* Unordered List */}
			<View style={styleSheet.unorderedList}>
				{islandData.map((island: ItemizedLineItem) => (
					<View key={island.sku} style={styleSheet.listItem}>
						<Text style={styleSheet.bulletPoint}>•</Text>
						<Text style={styleSheet.listItemText}>{`${island.sku} (x${island.qty})`}</Text>
					</View>
				))}
			</View>

			{/* Linear Feet and Cost */}
			<View style={styleSheet.infoRow}>
				<Text style={styleSheet.bold}>Total Linear Feet:</Text>
				<Text style={styleSheet.text}> {totalFeet} ft</Text>
			</View>

			<View style={styleSheet.infoRow}>
				<Text style={styleSheet.bold}>Assembly Cost:</Text>
				<Text style={styleSheet.text}> {formatPrice(assemblyCost)}</Text>
			</View>
		</View>
	);
};
